/* Beyond Cremation - Payment Processing Fee (recoups Shopify 2.9% + $0.30)
   Strategy: show fee as a display row in the cart drawer/page during browsing
   (no cart writes -> no loops, no "x88" clutter), and inject the real fee
   line item only when the customer clicks Checkout. */
(function () {
  "use strict";
  // LIVE for all customers (preview gate removed 2026-08-26). Fee scoped to a-la-carte only (see hasPackage).
  var FEE_VARIANT = 48501694202074;      // Payment Processing Fee variant
  var RATE = 0.029, FIXED_CENTS = 30;    // Shopify Payments online rate
  var NAVY = "#142e5c", LTBLUE = "#d7ebf7";
  var busy = false, checkingOut = false, lastSig = "";

  function money(c) { return "$" + (c / 100).toFixed(2); }
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }
  function baseCents(cart) {
    return cart.items.reduce(function (s, i) { return i.variant_id === FEE_VARIANT ? s : s + i.final_line_price; }, 0);
  }
  // At-need cremation packages: fee does NOT apply (a-la-carte only).
  var PACKAGE_IDS = [9173953806554, 9174000763098, 9174035202266, 9174048440538];
  function hasPackage(cart) { return cart.items.some(function (i) { return PACKAGE_IDS.indexOf(i.product_id) !== -1; }); }
  function desiredFee(cart) { if (hasPackage(cart)) return 0; var b = baseCents(cart); return b <= 0 ? 0 : Math.round(b * RATE) + FIXED_CENTS; }
  function feeLine(cart) { return cart.items.filter(function (i) { return i.variant_id === FEE_VARIANT; })[0]; }

  // Remove a stray fee line during browsing (e.g. customer used browser Back from checkout)
  function stripFee() {
    if (busy || checkingOut) return Promise.resolve();
    return getCart().then(function (cart) {
      var fl = feeLine(cart);
      if (!fl) return;
      busy = true;
      return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: fl.key, quantity: 0 }) }).then(function () { busy = false; });
    }).catch(function () { busy = false; });
  }

  // Display-only fee + estimated total inside cart drawer/page footers
  function renderFeeDisplay() {
    return getCart().then(function (cart) {
      var fee = desiredFee(cart), base = baseCents(cart);
      var sig = base + ":" + fee;
      var footers = document.querySelectorAll(".drawer__footer, .cart__footer");
      if (!footers.length) return;
      footers.forEach(function (footer) {
        var host = footer.querySelector(".js-bc-fee-block");
        if (fee <= 0) { if (host) host.remove(); return; }
        if (!host) {
          host = document.createElement("div");
          host.className = "js-bc-fee-block";
          host.style.cssText = "margin:0 0 12px;padding:10px 14px;background:" + LTBLUE + ";border-radius:8px;color:" + NAVY + ";font-size:1.4rem;line-height:1.5;";
          footer.insertBefore(host, footer.firstChild);
        }
        if (host.getAttribute("data-sig") === sig) return; // no change -> avoid observer loop
        host.setAttribute("data-sig", sig);
        host.innerHTML =
          '<div style="display:flex;justify-content:space-between;padding:3px 0;">' +
            '<span>Payment Processing Fee</span><span>' + money(fee) + '</span></div>' +
          '<div style="display:flex;justify-content:space-between;padding:6px 0;font-weight:700;border-top:1px solid rgba(20,46,92,.25);margin-top:4px;">' +
            '<span>Estimated Total</span><span>' + money(base + fee) + '</span></div>' +
          '<div style="font-size:1.1rem;opacity:.75;margin-top:2px;">Includes 2.9% + $0.30 card processing</div>';
      });
      lastSig = sig;
    }).catch(function () {});
  }

  function addFeeThenCheckout() {
    checkingOut = true;
    getCart().then(function (cart) {
      var fee = desiredFee(cart), fl = feeLine(cart), req;
      if (fee <= 0) { req = Promise.resolve(); }
      else if (fl) {
        req = (fl.quantity === fee) ? Promise.resolve() :
          fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: fl.key, quantity: fee }) });
      } else {
        req = fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: FEE_VARIANT, quantity: fee }) });
      }
      req.then(function () { window.location.href = "/checkout"; });
    });
  }

  // Intercept checkout clicks (drawer + cart page)
  document.addEventListener("click", function (ev) {
    var el = ev.target.closest('[name="checkout"], .cart__checkout-button, a[href="/checkout"], a[href^="/checkout?"]');
    if (!el) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    addFeeThenCheckout();
  }, true);

  // Keep the display fresh as the drawer re-renders
  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; setTimeout(function () { scheduled = false; renderFeeDisplay(); }, 120); }
  function init() {
    stripFee().then(renderFeeDisplay);
    new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
